import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import BookItem from "./BookItem";

const WrapperStyled = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    position: relative;
    min-height: 350px;
`;

const WrapperContainerStyled = styled.div`
    display: grid;
    position: relative;

    transition: left 0.5s cubic-bezier(0.37, 0, 0.63, 1) 0s;
    
    @media (max-width: 1000px) {
        grid-gap: 10px;
    }
`;

const WrapperOfWrapperContainerStyled = styled.div`
    overflow: hidden;

    &:focus {
        outline: 1px solid transparent;
    }
`;

const ItemStyled = styled.div`
    //display: grid;
`;

const DotsWrapperStyled = styled.div`
    position: absolute;
    bottom: -20px;
    display: grid;
    width: 100%;
    justify-content: center;
    grid-gap: 5px;

    @media (max-width: 1250px) {
        bottom: -1.7vw;
    }

    @media (max-width: 1000px) {
        bottom: -27px;
    }
`;

const DotsItemStyled = styled.div`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    cursor: pointer;

    background: #ffa927;

    &:hover {
        background: #ffc43d;
    }

    &.active {
        background: #ffd542;
    }
`;

const SliderOneByOne = ({ items, lang, langData, maxInRow, maxRows, config }) => {
    const sliderRef = useRef(null);
    const wrapperSliderRef = useRef(null);
    const [startX, setStartX] = useState(null);
    const [isDragging, setIsDragging] = useState(false);
    const [difference, s_difference] = useState(0);
    const [index, s_index] = useState(maxInRow); // Start from first actual item, offset by maxInRow
    const [isAnimating, setIsAnimating] = useState(true);
    const [isPaused, setIsPaused] = useState(false);
    const [diff, setDifference] = useState(0);

    const clonedItems = [
        ...items.slice(-maxInRow), // Clone the last few
        ...items,
        ...items.slice(0, maxInRow) // Clone the first few
    ];


    const itemsLength = items.length;
    const totalSlides = clonedItems.length; // Includes clones
    const containerWidth = (100 / maxInRow) * totalSlides;

    const handleTouchStart = (e) => {
        setIsPaused(true); // Pause auto-slide on touch
        setStartX(e.touches[0].clientX);
        setIsDragging(true);
    };

    const handleTouchMove = (e) => {
        if (!isDragging) return;
        const currentX = e.touches[0].clientX;
        s_difference(startX - currentX);
        setStartX(currentX);
    };

    const handleStart = (e) => {
        setIsPaused(true);
        setStartX(e.touches ? e.touches[0].clientX : e.clientX);
        setIsDragging(true);
    };

    const handleMove = (e) => {
        if (!isDragging) return;
        const currentX = e.touches ? e.touches[0].clientX : e.clientX;
        setDifference(startX - currentX);
    };

    const handleEnd = () => {
        setIsDragging(false);
        setIsPaused(false);
        const oneElementDif = 1000 / maxInRow;
        const indexes = Math.floor(diff / oneElementDif);
        if (diff > 50) {
            s_index(index + indexes);
        }
        else if (diff < -50) {
            s_index(index - indexes);
        }
        setDifference(0);
    };

    // useEffect(() => {
    //     const slider = sliderRef.current;
    //     slider.addEventListener("mousedown", handleStart);
    //     slider.addEventListener("mousemove", handleMove);
    //     slider.addEventListener("mouseup", handleEnd);
    //     slider.addEventListener("mouseleave", handleEnd);
    //     slider.addEventListener("touchstart", handleStart);
    //     slider.addEventListener("touchmove", handleMove);
    //     slider.addEventListener("touchend", handleEnd);
    //
    //     return () => {
    //         slider.removeEventListener("mousedown", handleStart);
    //         slider.removeEventListener("mousemove", handleMove);
    //         slider.removeEventListener("mouseup", handleEnd);
    //         slider.removeEventListener("mouseleave", handleEnd);
    //         slider.removeEventListener("touchstart", handleStart);
    //         slider.removeEventListener("touchmove", handleMove);
    //         slider.removeEventListener("touchend", handleEnd);
    //     };
    // }, [isDragging, startX, diff]);

    useEffect(() => {
        if (!isDragging) {
            if (difference < 0) {
                // Swipe left
                nextPrev(true);
            } else if (difference > 0) {
                // Swipe right
                nextPrev(false);
            }
            s_difference(0);
        }
    }, [difference, isDragging]);

    const handleTouchEnd = () => {
        setIsDragging(false);
        setIsPaused(false); // Resume auto-slide after touch ends
    };

    const nextPrev = (isPrev) => {
        if (!isAnimating) return;
        setIsAnimating(true);

        let newIndex = isPrev ? index - 1 : index + 1;
        s_index(newIndex);

        setTimeout(() => {
            if (newIndex < maxInRow) {
                setIsAnimating(false);
                s_index(itemsLength + newIndex);
            } else if (newIndex >= itemsLength + maxInRow) {
                setIsAnimating(false);
                s_index(newIndex - itemsLength);
            }
        }, 500);
    };

    const startAutoSlide = () => {
        if (!isPaused) {
            nextPrev(false); // Move to the next slide
        }
    };

    useEffect(() => {
        const interval = setInterval(startAutoSlide, 2000);
        return () => clearInterval(interval);
    }, [isPaused, index]);

    const dots = Array.from({ length: itemsLength }, (_, idx) => idx);
    let left = `${ -100 / maxInRow * index }%`;
    if (lang === "he" || lang === "ar") {
        left = `${ 100 / maxInRow * index }%`;
    }

    return (
        <WrapperStyled ref={ wrapperSliderRef }>
            <WrapperOfWrapperContainerStyled
                ref={ sliderRef }
                onTouchStart={ handleTouchStart }
                onTouchMove={ handleTouchMove }
                onTouchEnd={ handleTouchEnd }
                role="radiogroup"
                aria-label={ langData.arias.choose_template }
            >
                <WrapperContainerStyled
                    style={ {
                        width: `${ containerWidth }%`,
                        left: left,
                        gridTemplateColumns: `repeat(${ totalSlides }, 1fr)`,
                        transition: isAnimating ? "left 0.5s cubic-bezier(0.37, 0, 0.63, 1)" : "none" // Disable during reset
                    } }
                    onTransitionEnd={ () => setIsAnimating(true) } // Re-enable animation after transitions
                >
                    { clonedItems.map((itm, idxx) => {
                        const indexInItems = items.findIndex((pp) => pp._id === itm._id);

                        return (
                            <ItemStyled
                                role="radio"
                                aria-setsize={ itemsLength }
                                aria-posinset={ indexInItems + 1 }
                                key={ idxx }
                            >
                                <BookItem
                                    config={config}
                                    lang={ lang }
                                    langData={ langData }
                                    item={ itm }
                                />
                            </ItemStyled>
                        );
                    }) }
                </WrapperContainerStyled>
            </WrapperOfWrapperContainerStyled>
            <DotsWrapperStyled
                style={ {
                    gridTemplateColumns: `repeat(${ itemsLength }, 10px)`
                } }
            >
                { dots.map((dot) => (
                    <DotsItemStyled
                        onClick={ () => {
                            setIsPaused(true); // Pause auto-slide on dot click
                            s_index(dot + maxInRow); // Adjust index to consider cloned items
                            setTimeout(() => setIsPaused(false), 2000); //
                        } }
                        key={ dot }
                        className={ index === dot + maxInRow ? "active" : "" }
                    />
                )) }
            </DotsWrapperStyled>
        </WrapperStyled>
    );
};

export default SliderOneByOne;
